<h3 class="page-subheader" *ngIf="title">{{ title }}</h3>

<div class="row form-row" *ngIf="matchers.global.errors.length > 0">
    <div class="col">
        <app-message-box [errorStateMatcher]="matchers.global"></app-message-box>
    </div>
</div>

<div class="row form-row">
    <div class="col-auto size-country" *ngIf="allowForeign">
        <app-select
                [ngModel]="address.country?.code"
                [label]="'LABEL.COUNTRY' | translate"
                (ngModelChange)="onCountryChange($event)"
                [itemList]="(dictionaries$|async)[dictionaryTypes.COUNTRY].itemList"
                [errorStateMatcher]="matchers.country">
        </app-select>
    </div>

    <div class="col-auto size-postal-code">
        <app-input *ngIf="address.country?.code !== 'PL'"
                   [(ngModel)]="address.postalCode"
                   [maxLength]="10"
                   [errorStateMatcher]="matchers.postalCode"
                   [label]="'LABEL.POST_CODE' | translate">
        </app-input>

        <app-input-mask
                *ngIf="address.country?.code === 'PL'"
                [textMask]="{mask: '00-000', lazy: false}"
                (onBlur)="getCities()"
                [(ngModel)]="address.postalCode"
                [errorStateMatcher]="matchers.postalCode"
                [label]="'LABEL.POST_CODE' | translate">
        </app-input-mask>
    </div>

    <div class="col-auto size-city">
        <app-input *ngIf="address.country?.code !== 'PL'"
                   [(ngModel)]="address.city"
                   [maxLength]="100"
                   [errorStateMatcher]="matchers.city"
                   [label]="'LABEL.CITY' | translate">
        </app-input>

        <app-select *ngIf="address.country?.code === 'PL'"
                    [ngModel]="address.city"
                    (ngModelChange)="setCity($event)"
                    [errorStateMatcher]="matchers.city"
                    [disabled]="cities.length === 0"
                    [itemList]="cities"
                    bindDescription="code"
                    bindValue="code"
                    [label]="'LABEL.CITY' | translate">
        </app-select>
    </div>
</div>

<div class="row form-row">
    <div class="col-auto size-adr-prefix-street">
        <app-select [disabled]="address.country?.code !== 'PL'"
                [ngModel]="address.streetPrefix?.code"
                (ngModelChange)="address.streetPrefix = {code: $event}"
                [errorStateMatcher]="matchers.streetPrefix"
                [hasEmpty]="false"
                [itemList]="(dictionaries$ | async)[dictionaryTypes.LOCALITY_TYPE].itemList"
                [label]="'LABEL.STREET_PREFIX' | translate">
        </app-select>
    </div>


    <div class="col-auto size-adr-street" *ngIf="address.country?.code !== 'PL'">
        <app-input [(ngModel)]="address.streetName"
                   [maxLength]="100"
                   [errorStateMatcher]="matchers.streetName"
                   [label]="'LABEL.STREET' | translate">
        </app-input>
    </div>

    <ng-container *ngIf="address.country?.code === 'PL'">
        <div class="col-auto size-adr-street" *ngIf="!allowCityInput">
            <app-select [(ngModel)]="address.streetName"
                        [errorStateMatcher]="matchers.streetName"
                        [disabled]="streets.length === 0"
                        [itemList]="streets"
                        bindDescription="code"
                        bindValue="code"
                        [label]="'LABEL.STREET' | translate">
            </app-select>
        </div>

        <div class="col-auto size-adr-street" *ngIf="allowCityInput">
            <app-input [(ngModel)]="address.streetName"
                       [errorStateMatcher]="matchers.streetName"
                       [label]="'LABEL.STREET' | translate">
            </app-input>
        </div>
    </ng-container>

    <div class="col-auto size-adr-street-number">
        <app-input [(ngModel)]="address.streetNumber"
                   [maxLength]="20"
                   [errorStateMatcher]="matchers.streetNumber"
                   [label]="'LABEL.STREET_NUMBER' | translate">
        </app-input>
    </div>

    <div class="col-auto size-adr-door">
        <app-input [(ngModel)]="address.apartmentNumber"
                   [disabled]="disableApartment"
                   [maxLength]="20"
                   [errorStateMatcher]="matchers.apartmentNumber"
                   [label]="'LABEL.DOOR_NUMBER' | translate">
        </app-input>
    </div>
</div>


